import React, { useRef, useEffect, useState } from 'react';
import Config from '../../values/Strings/Config';

//TODO: Make this responsive

const CrosswordExtractor = ({ getCrosswordSingleData }) => {
    const canvasRef = useRef(null);
    const [grid, setGrid] = useState(Array.from({ length: 13 }, () => new Array(13).fill(0)));
    const [cellSize, setCellSize] = useState(47.5);
    const [textInputs, setTextInputs] = useState(Array.from({ length: 13 }, () => new Array(13).fill('')));

    useEffect(() => {
        const processImage = async () => {
            if (!getCrosswordSingleData?.data?.image) {
                console.warn("Crossword image data is not available.");
                return; // Exit if no data
            }

            const img = new Image();
            img.crossOrigin = 'Anonymous';
            const imageUrl = `${Config.CROSSWORD_URL}${getCrosswordSingleData.data.image}`;
            img.src = imageUrl;

            img.onload = () => {
                const canvas = canvasRef.current;
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0, img.width, img.height);

                const imageData = ctx.getImageData(0, 0, img.width, img.height);
                const data = imageData.data;

                const rows = 13;
                const cols = 13;
                const cellWidth = img.width / cols;
                const cellHeight = img.height / rows;
                const newGrid = Array.from({ length: rows }, () => new Array(cols).fill(0));

                for (let row = 0; row < rows; row++) {
                    for (let col = 0; col < cols; col++) {
                        const startX = Math.floor(col * cellWidth);
                        const startY = Math.floor(row * cellHeight);
                        const endX = Math.ceil((col + 1) * cellWidth);
                        const endY = Math.ceil((row + 1) * cellHeight);

                        let blackCount = 0;
                        let whiteCount = 0;

                        for (let y = startY; y < endY; y++) {
                            for (let x = startX; x < endX; x++) {
                                const index = (y * img.width + x) * 4;
                                const r = data[index];
                                const g = data[index + 1];
                                const b = data[index + 2];

                                if (r === 0 && g === 0 && b === 0) {
                                    blackCount++;
                                } else {
                                    whiteCount++;
                                }
                            }
                        }
                        newGrid[row][col] = whiteCount > blackCount ? 1 : 0;
                    }
                }
                setGrid(newGrid);
                console.log("Processed Grid:", newGrid);
                console.log(`https://cors-anywhere.herokuapp.com/${Config.CROSSWORD_URL}${getCrosswordSingleData.data.image}`);
            };

            img.onerror = (error) => {
                console.error("Error loading the image:", error);
            };
        };

        processImage();

        console.log("getCrosswordSingleData:", getCrosswordSingleData);
    }, [getCrosswordSingleData]);


     // Dynamically adjust cell size based on screen width
     useEffect(() => {
        const updateCellSize = () => {
            const screenWidth = window.innerWidth;
            setCellSize(screenWidth < 600 ? 25 : 47.5);
        };

        updateCellSize(); // Set initial cell size based on current screen width
        window.addEventListener('resize', updateCellSize); // Update cell size on window resize

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', updateCellSize);
    }, []);


    const handleKeyDown = (row, col, event) => {
        const { key } = event;

        // Check if the key pressed is a single character
        if (key.length === 1) {
            // Update the text input for the specific cell to the new value, replacing the old character
            const updatedInputs = textInputs.map((r, rowIndex) =>
                r.map((cell, colIndex) => (rowIndex === row && colIndex === col ? key : cell))
            );
            setTextInputs(updatedInputs);
        }
    };

    return (
        <div>
            <canvas ref={canvasRef} style={{ display: 'none' }} />
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${grid[0]?.length}, ${cellSize}px)`,
                    gap: '1px' // Optional gap to separate cells slightly
                }}
            >
                {grid.map((row, rowIndex) => (
                    row.map((cell, colIndex) => (
                        <div
                            key={`${rowIndex}-${colIndex}`}
                            style={{
                                width: `${cellSize}px`,
                                height: `${cellSize}px`,
                                backgroundColor: cell === 1 ? 'white' : 'black', // White for editable, black for non-editable
                                border: '1px solid gray',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative'
                            }}
                        >
                            {cell === 0 ? (
                                <div style={{ opacity: 0.01 }}>😊</div> // Optional symbol for non-editable cells
                            ) : (
                                <input
                                    type="text"
                                    value={textInputs[rowIndex][colIndex]}
                                    onKeyDown={(e) => handleKeyDown(rowIndex, colIndex, e)}
                                    maxLength={1}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        border: 'none',
                                        outline: 'none',
                                        textAlign: 'center',
                                        background: 'transparent', // Transparent background
                                        color: 'black',
                                        fontSize: `${cellSize / 2}px`,
                                        textTransform: 'uppercase',
                                        pointerEvents: 'auto' // Allow input
                                    }}
                                />
                            )}
                        </div>
                    ))
                ))}
            </div>
        </div>
    );
};

export default CrosswordExtractor;
